import React, { useState, useEffect } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { InboxOutlined } from "@ant-design/icons";
import { message, Upload } from "antd";
import "./AddCertificate.css";
import PostApiCall from "../../../helpers/PostApi";
import Notiflix from "notiflix";
import { useLocation, useNavigate } from "react-router-dom";
import { IoEyeOutline } from "react-icons/io5";
import { BsPlus, BsPlusLg } from "react-icons/bs";
import { FaEdit } from "react-icons/fa";
const { Dragger } = Upload;

const AddCertificate = () => {
  const navigate = useNavigate()
  const state = useLocation();
  const dataToEdit = state.state?.certificateData;

  const [name, setName] = useState("");
  const [mobile, setMobile] = useState("");
  const [email, setEmail] = useState("");
  const [imgSize, setImgSize] = useState("");
  const [certificate, setCertificate] = useState("");
  const [image, setImage] = useState("");
  const [fileList, setFileList] = useState([]);
  // const emailRagex = /^[a-zA-Z0-9._%+-]+@([a-zA-Z0-9-]+\.){1,2}[a-zA-Z]{2,4}$/;
  const certificateRagex = /^[A-Z]{4}[0-9]{3,4}(JA|FE|MA|AP|MY|JN|JL|AU|SE|OC|NV|DE)[0-9]{2}$/;

  useEffect(() => {
    if (dataToEdit) {
      setName(dataToEdit?.fld_name);
      setCertificate(dataToEdit?.fld_certificate_number);
      setMobile(dataToEdit?.fld_mobile);
      setEmail(dataToEdit?.fld_email);
      setImage(dataToEdit?.fld_certificate_url);
      setImgSize(dataToEdit?.fld_file_size);
    } else {
      setImage("")
      setName("");
      setCertificate("");
      setMobile("");
      setEmail("");
      setImgSize("");
    }
  }, [dataToEdit])
  const props = {
    name: "file",
    fileList: fileList,
    maxCount: 1,
    multiple: false,
    beforeUpload: (file) => {
      const isImage =
        file.type === "image/jpeg" || file.type === "image/png" || file.type === "image/jpg";

      if (!isImage) {
        Notiflix.Notify.failure("You can only upload JPEG or PNG files!");
        return Upload.LIST_IGNORE;
      }


      return isImage;
    },
    customRequest: async ({ file, onSuccess, onError }) => {
      try {
        Notiflix.Loading.dots()
        const formData = new FormData();
        formData.append("filename", file.name?.trim().replace(/\s/g, "-"));
        formData.append("foldername", "");
        formData.append("file", file);

        const response = await fetch(
          "https://sreeharidiamondlab.com/api/AddImage",
          {
            method: "POST",
            body: formData,
          }
        );

        if (response.ok) {
          const result = await response.json(); // or .text() depending on your API
          onSuccess(result);
          setFileList([]);
          setImage(result.image)
          Notiflix.Loading.remove();
          message.success(`${file.name} uploaded successfully.`);
        } else {
          Notiflix.Loading.remove();
          throw new Error("Upload failed");
        }
      } catch (err) {
        Notiflix.Loading.remove();
        console.error(err);
        onError(err);
        message.error(`${file.name} upload failed.`);
      }
    },
    onChange(info) {
      const sizeInKb = info?.file?.size / 1024;
      setImgSize(Math.floor(sizeInKb))

    },
    onDrop(e) {
      // console.log("Dropped files", e.dataTransfer.files);
    },
  };

  const handleInputChange = (name, value) => {
    if (name === "mobile") {
      const mobileValue = value.replace(/[^0-9]/g, "").slice(0, 12);
      setMobile(mobileValue);
    }
  };



  const AddCertificate = () => {
    if (!certificate) {
      Notiflix.Notify.failure("Please enter certificate number");
      return;
    }
    if (!certificateRagex.test(certificate)) {
      Notiflix.Notify.failure("Please enter valid certificate number");
      return;
    }
    if (!name) {
      Notiflix.Notify.failure("Please enter name");
      return;
    }
    // if (!email) {
    //   Notiflix.Notify.failure("Please enter email address");
    //   return;
    // }
    // if (!emailRagex.test(email)) {
    //   Notiflix.Notify.failure("Please enter valid email address");
    //   return;
    // }
    if (!mobile || (mobile?.length < 10)) {
      Notiflix.Notify.failure("Please enter valid mobile number");
      return;
    }
    if (!image) {
      Notiflix.Notify.failure("Please upload certificate image");
      return;
    }
    try {
      Notiflix.Loading.dots();
      PostApiCall.postRequest(
        {
          id: dataToEdit ? dataToEdit?.fld_id : null,
          name: name,
          certificate: certificate,
          mobile: mobile,
          email: email,
          certificateurl: image,
          status: "Active",
          filesize: imgSize
        },
        "AddCertificate"
      ).then((result) =>
        result.json().then((obj) => {
          if (result.status === 200 || result.status === 201) {
            setName("")
            setImage("")
            setMobile("")
            setEmail("")
            setCertificate("")
            setImgSize("")
            Notiflix.Notify.success("Certificate added successfully.");
            Notiflix.Loading.remove();
            navigate("/admin/certificatelist")
          } else {
            Notiflix.Loading.remove();
            Notiflix.Notify.failure(obj?.data);
          }
        })
      );
    } catch (err) {
      console.log(err)
      Notiflix.Loading.remove();
    }
  };
  return (
    <>
      <section className="certificate-section section-spacing-x">
        <Container fluid className="">
          <div className="certificate-form text-white">
            <div className="section-bootom-border pb-3 mb-3">
              <h1 className="text-start text-white mb-0">Add Certificate</h1>
            </div>
            <Form>
              <Row>
                <Col lg={6} className="mb-0">
                  {" "}
                  <Form.Group className="mb-3 form-inputs">
                    <Form.Label>Certificate Number</Form.Label>
                    <Form.Control
                      type="text"
                      name="Certificate Number"
                      placeholder="Enter Certificate Number"
                      required
                      value={certificate}
                      onChange={(e) => setCertificate(e.target.value?.toUpperCase())}
                    />
                  </Form.Group>
                </Col>
                <Col lg={6} className="mb-0">
                  {" "}
                  <Form.Group className="mb-3 form-inputs">
                    <Form.Label>Name</Form.Label>
                    <Form.Control
                      type="text"
                      name="Name"
                      placeholder="Enter Customer Name"
                      required
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                    />
                  </Form.Group>
                </Col>

                <Col lg={6} className="mb-2">
                  {" "}
                  <Form.Group className="mb-3 form-inputs">
                    <Form.Label>Email address</Form.Label>
                    <Form.Control
                      type="email"
                      name="email"
                      placeholder="Enter Customer Email"
                      required
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </Form.Group>
                </Col>
                <Col lg={6} className="mb-2">
                  <Form.Group className="mb-3 form-inputs">
                    <Form.Label>Mobile Number</Form.Label>
                    <Form.Control
                      type="text"
                      name="Number"
                      placeholder="Customer's Mobile Number"
                      required
                      value={mobile}
                      onChange={(e) => handleInputChange("mobile", e.target.value)}
                    />
                  </Form.Group>
                </Col>

                <Dragger {...props} className="form-inputs" >
                  <p className="ant-upload-drag-icon">
                    <InboxOutlined />
                  </p>
                  <p className="ant-upload-text">Upload Certificate</p>
                  <p className="ant-upload-hint">
                    Support for a single or bulk upload. Strictly prohibited
                    from uploading company data or other banned files.
                  </p>
                </Dragger>
                {image && <div className="mt-2">
                  <Button type="button" variant="light" onClick={() => window.open(image, "_blank")}>
                    <IoEyeOutline />  View Certificate
                  </Button></div>}

                <div className="text-end mt-5">
                  {dataToEdit ?
                    <Button variant="light" onClick={AddCertificate} className="d-flex gap-1 align-items-center ms-auto">
                      <FaEdit />  Edit
                    </Button> :
                    <Button variant="light" onClick={AddCertificate} className="d-flex gap-1 align-items-center ms-auto">
                      <BsPlusLg />  Add
                    </Button>}
                </div>
              </Row>
            </Form>
          </div>
        </Container>
      </section>
    </>
  );
};

export default AddCertificate;
